module.exports = __webpack_public_path__ + "img/adouy2.5c321b89.png";